<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->
<div class="container" appLifecycleTracker trackerName="admin-settings" *ngrxLet="haveDDTier$ as haveDDTier">
	<div *ngIf="settingsDataLoaded">
		<span class="settings-data-loaded"></span>
	</div>
	<div class="settings-content" *ngIf="adminSettings !== null; else noAdminSettings">
        <div class="action-buttons">
            <span class="cancel-wrapper">
                <button id="cancel-button" mat-raised-button (click)="onCancel()" [disabled]="!isDirty" class="cancel-button">
                    {{fCancel}}
                </button>
            </span>
            <span class="submit-button-wrapper">
                <button id="submit-button" (click)="onSubmit()"
                        [disabled]="!isDirty || !orgFormGroup.valid" mat-flat-button color="primary" type="submit">
                    {{fSubmit}}
                </button>
            </span>
        </div>
        <mat-tab-group [(selectedIndex)]="selectedTab" animationDuration="0ms">
          <mat-tab *ngIf="this.allAdminSettingsViewable && haveDDTier" label="{{'APP_FILE_ENCRYPTION' | translate}}">

              <div [attr.inert]="haveDDTier ? null : ''">

                  <div class="setting-wrapper">
                      <div id="enable-subscription-key" class="setting-header">
                          <label class="setting-title">{{'ENABLE_SUBSCRIPTION_KEY_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_SUBSCRIPTION_KEY_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                              #enableSubscriptionKeyControl
                              labelPosition="before"
                              aria-labelledby="enable-subscription-key"
                              color="primary"
                              id="enable-sub-toggle"
                              [disableRipple]="true"
                              (change)="onEnableSubscriptionKeyChanged('enable_subscription_key', $event.checked)"
                              [checked]="enableSubscriptionKey">
                              {{enableSubscriptionKey ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                  </div>

                  <div class="setting-wrapper">
                      <div id="enable-recovery-key" class="setting-header" aria-label="Add recovery key to all user encrypted files for emergency access">
                          <label class="setting-title">{{'ENABLE_RECOVERY_KEY_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_RECOVERY_KEY_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  color="primary"
                                  id="enable-recovery-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableRecoveryKey', $event.checked)"
                                  [checked]="enableRecoveryKey"
                                  aria-labelledby="enable-recovery-key">
                              {{enableRecoveryKey ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                  </div>

                  <div class="setting-wrapper" *ngIf="showAutoImportButton">
                      <div id="enable-auto-import-button" class="setting-header"
                           aria-label="Send all users defined in console to Cigent endpoints to make file sharing easier">
                          <label class="setting-title">{{'ENABLE_USER_SYNC_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_USER_SYNC_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="enable-auto-import-button"
                                  color="primary"
                                  id="enable_auto_import_toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableAutoImport', $event.checked)"
                                  [checked]="enableAutoImport">
                              {{enableAutoImport ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                  </div>

                  <div class="setting-wrapper">
                      <div id="require-password-key" class="setting-header"
                           aria-label="Require the use of a password for every manually created key in the console">
                          <label class="setting-title">{{'ENABLE_PASS_PROTECT_KEYS_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_PASS_PROTECT_KEYS_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="require-password-key"
                                  color="primary"
                                  id="require-password-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('requireKeyPassword', $event.checked)"
                                  [checked]="requireKeyPassword">
                              {{requireKeyPassword ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                  </div>

                  <div class="setting-wrapper">
                      <div id="enable-permissive-decryption" class="setting-header"
                           aria-label="Only allow subscription users to sign into your subscription licensed Cigent endpoints">
                          <label class="setting-title">{{'ENABLE_RESTRICT_SIGN_IN_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_RESTRICT_SIGN_IN_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="enable-permissive-decryption"
                                  color="primary"
                                  id="enable-permissive-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableSignOnRestriction', $event.checked)"
                                  [checked]="enableSignOnRestriction">
                              {{enableSignOnRestriction ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                  </div>

              </div>

          </mat-tab>
          <mat-tab id="sensors" label="Sensors" *ngIf="showRemovableStorage || showEnableDataDeception || showEnableNetworkDeception || showEnableTrustedNetwork">
              <div [attr.inert]="haveDDTier ? null : ''">

                  <div *ngIf="userCanClearSensorFeatureFlag" style="border-bottom: none; padding: 0; margin: 25px 50px -25px 25px;" class="setting-wrapper">
                      <div id="user-can-clear-label-wrapper" class="setting-header"></div>
                      <div>{{'USER_CAN_CLEAR_LABEL' | translate}}</div>
                  </div>
                  <div class="setting-wrapper" *ngIf="showRemovableStorage">
                      <div id="enable-usb-wrapper" class="setting-header"
                           aria-label="Require authentication when a new USB storage device is connected">
                          <label class="setting-title">{{'ENABLE_USB_STORAGE_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_USB_STORAGE_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="enable-usb-toggle"
                                  color="primary"
                                  id="enable-usb-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableRemovableStorage', $event.checked)"
                                  [checked]="enableRemovableStorage">
                              {{enableRemovableStorage ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                      <mat-checkbox *ngIf="userCanClearSensorFeatureFlag" class="can-clear-checkbox"
                                    [checked]="true" name="userCanClearUSB"
                                    [disabled]="true" matTooltip="{{'USER_CAN_CLEAR_CANNOT_BE_DISABLED' | translate}}"
                                    color="primary" data-lpignore="true">
                      </mat-checkbox>
                  </div>

                  <div class="setting-wrapper" *ngIf="showEnableDataDeception">
                      <div id="data-deception-header" class="setting-header"
                           aria-label="Create interesting looking files to entice malicious actors">
                          <label class="setting-title">{{'ENABLE_DATA_DECEPTION_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_DATA_DECEPTION_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="data-deception-toggle"
                                  color="primary"
                                  id="data-deception-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableDataDeception', $event.checked)"
                                  [checked]="enableDataDeception">
                              {{enableDataDeception ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                      <mat-checkbox *ngIf="userCanClearSensorFeatureFlag" class="can-clear-checkbox"
                                    [checked]="enableClearDataDeception" name="userCanClearDataDeception"
                                    [disabled]="!enableDataDeception"
                                    (change)="onToggleSetting('enableClearDataDeception', $event.checked)"
                                    color="primary" data-lpignore="true">
                      </mat-checkbox>
                  </div>

                  <div class="setting-wrapper" *ngIf="showEnableNetworkDeception">
                      <div id="network-deception-header" class="setting-header"
                           aria-label="Create services on commonly exploited ports to entice malicious actors">
                          <label class="setting-title">{{'ENABLE_NETWORK_DECEPTION_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_NETWORK_DECEPTION_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="network-deception-toggle"
                                  color="primary"
                                  id="network-deception-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableNetworkDeception', $event.checked)"
                                  [checked]="enableNetworkDeception">
                              {{enableNetworkDeception ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                      <mat-checkbox *ngIf="userCanClearSensorFeatureFlag" class="can-clear-checkbox"
                                    [checked]="enableClearNetworkDeception" name="userCanClearNetworkDeception"
                                    [disabled]="!enableNetworkDeception"
                                    (change)="onToggleSetting('enableClearNetworkDeception', $event.checked)"
                                    color="primary" data-lpignore="true">
                      </mat-checkbox>
                  </div>

                  <div class="setting-wrapper" *ngIf="showEnableTrustedNetwork">
                      <div id="trusted-network-header" class="setting-header"
                           aria-label="Require authentication when joining a new network for the first time">
                          <label class="setting-title">{{'ENABLE_TRUSTED_NETWORK_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_TRUSTED_NETWORK_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="trusted-network-toggle"
                                  id="trusted-network-toggle"
                                  color="primary"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableTrustedNetwork', $event.checked)"
                                  [checked]="enableTrustedNetwork">
                              {{enableTrustedNetwork ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                      <mat-checkbox *ngIf="userCanClearSensorFeatureFlag" class="can-clear-checkbox"
                                    [checked]="true" name="enableClearTrustedNetwork"
                                    [disabled]="true" matTooltip="{{'USER_CAN_CLEAR_CANNOT_BE_DISABLED' | translate}}"
                                    color="primary" data-lpignore="true">
                      </mat-checkbox>
                  </div>

                  <div class="setting-wrapper" *ngIf="showEnableTrustedNetwork">
                      <div id="antivirus-tethering-header" class="setting-header"
                           aria-label="Enable anti-virus tethering on endpoints.">
                          <label class="setting-title">{{'ENABLE_ANTIVIRUS_TETHERING_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENABLE_ANTIVIRUS_TETHERING_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="antivirus-tethering-toggle"
                                  id="antivirus-tethering-toggle"
                                  color="primary"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableAVTethering', $event.checked)"
                                  [checked]="enableAVTethering">
                              {{enableAVTethering ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                      <mat-checkbox *ngIf="userCanClearSensorFeatureFlag" class="can-clear-checkbox"
                                    [checked]="false" name="enableClearTrustedNetwork"
                                    [disabled]="true" matTooltip="{{'ENABLE_ANTIVIRUS_TETHERING_CHECKBOX_TOOLTIP' | translate}}"
                                    color="primary" data-lpignore="true">
                      </mat-checkbox>
                  </div>
              </div>
          </mat-tab>
          <mat-tab label="{{'D3ED_AUTH' | translate}}" *ngIf="showEnableMfaOtp || showEnableMfaFinger || showEnableMfaFace || showEnableMfaCac">
              <div class="note">{{'settings.auth.note' | translate}}</div>

              <div class="setting-wrapper" *ngIf="showEnableMfaOtp">
                  <div id="mfa-otp-header" class="setting-header" aria-label="Authenticator App">
                      <label class="setting-title">{{'AUTH_APP' | translate}}</label>
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="mfa-otp-toggle"
                          color="primary"
                          id="mfa-otp-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableMfaOtp', $event.checked)"
                          [checked]="enableMfaOtp">
                          {{enableMfaOtp ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
              </div>

              <div class="setting-wrapper" *ngIf="showEnableMfaFinger">
                  <div id="mfa-finger-header" class="setting-header" aria-label="Fingerprint">
                      <label class="setting-title">{{'FINGERPRINT' | translate}}</label>
                      <label class="setting-description">
                        <span class="mdi mdi-alert"></span>
                        {{'settings.auth.deprecated-description' | translate}}
                      </label>
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="mfa-finger-toggle"
                          color="primary"
                          id="mfa-finger-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableMfaFinger', $event.checked)"
                          [checked]="enableMfaFinger">
                          {{enableMfaFinger ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
              </div>

              <div class="setting-wrapper" *ngIf="showEnableMfaFace">
                  <div id="mfa-face-header" class="setting-header" aria-label="Facial Recognition">
                  <label class="setting-title">{{'FACE_RECOGNITION' | translate}}</label>
                  <label class="setting-description">
                    <span class="mdi mdi-alert"></span>
                    {{'settings.auth.deprecated-description' | translate}}
                  </label>
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="mfa-face-toggle"
                          color="primary"
                          id="mfa-face-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableMfaFace', $event.checked)"
                          [checked]="enableMfaFace">
                          {{enableMfaFace ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
              </div>

              <div class="setting-wrapper" *ngIf="showEnableMfaCac">
                  <div id="mfa-cac-header" class="setting-header" aria-label="CAC/PIV">
                      <label class="setting-title">CAC/PIV</label> <!-- no translation needed -->
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="mfa-cac-toggle"
                          color="primary"
                          id="mfa-cac-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableMfaCac', $event.checked)"
                          [checked]="enableMfaCac">
                          {{enableMfaCac ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
              </div>
          </mat-tab>

          <mat-tab label="{{'updates' | translate}}" *ngIf="showEnableAutoUpdate">
              <div style="border-bottom: none; padding: 0; margin: 25px 50px -25px 25px;" class="setting-wrapper">
                  <div id="user-can-clear-label-wrapper" class="setting-header"></div>
                  <div>{{'UPDATES_ENABLED_LABEL' | translate}}</div>
              </div>
              <div class="setting-wrapper" *ngIf="showEnableAutoUpdate">
                  <div id="auto-update-header" class="setting-header"
                       aria-label="Allow Cigent endpoints to auto update">
                      <label class="setting-title">{{'settings.updates.update.title' | translate}}</label>
                      <label class="setting-description">{{'settings.updates.update.description' | translate}}</label>
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="auto-update-toggle"
                          color="primary"
                          id="auto-update-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableAutoUpdate', $event.checked)"
                          [checked]="enableAutoUpdate">
                          {{enableAutoUpdate ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
                  <mat-checkbox *ngIf="showEnableAutoUpdate" class="can-clear-checkbox"
                          [checked]="enableClientUpdate" name="showClientUpdate"
                          [disabled]="false" matTooltip="{{'ENABLE_USER_UPDATE_TOOLTIP' | translate}}"
                          (change)="onToggleSetting('enableClientUpdate', $event.checked)"
                          color="primary" data-lpignore="true">
                  </mat-checkbox>
              </div>
          </mat-tab>
          <mat-tab label="{{'PIN_PASSWORD' | translate}}">
              <h2>{{'CONSOLE' | translate}}</h2>
              <div class="setting-wrapper">
                  <div id="password-lock-count" class="setting-header"
                       aria-label="Allow Cigent endpoints to auto update">
                      <label class="setting-title">{{'PASSWORD_LOCK_INTERVAL' | translate}}</label>
                      <label class="setting-description">{{'PASSWORD_LOCK_INTERVAL_DESCRIPTION' | translate}}</label>
                  </div>
                  <div>
                      <app-numeric-input
                              id="password-lock-count-input"
                              aria-labelledby="password-lock-count"
                              [min]="1" [max]="10" step="1" [value]="loginAttempts"
                              [showProgressBar]="true"
                              labelPosition="left"
                              inputPosition="right"
                              [showMinMax]="true"
                              (valueChanged)="onPassLockCountChanged($event)">
                      </app-numeric-input>
                  </div>
              </div>
              <div class="setting-wrapper">
                  <div id="password-reset-interval" class="setting-header"
                       aria-label="Allow Cigent endpoints to auto update">
                      <label class="setting-title">{{'PASSWORD_RESET_INTERVAL' | translate}}</label>
                      <label class="setting-description">{{'PASSWORD_RESET_INTERVAL_DESCRIPTION' | translate}}</label>
                  </div>
                  <div>
                        <app-numeric-input
                                id="password-reset-interval-input"
                                aria-labelledby="password-reset-interval"
                                [min]="1" [max]="12" step="1" [value]="pwExpInterval"
                                [showProgressBar]="true"
                                labelPosition="left"
                                inputPosition="right"
                                [showMinMax]="true"
                                (valueChanged)="onPassIntervalChanged($event)">
                        </app-numeric-input>
                  </div>
              </div>
              <div class="setting-wrapper">
                  <div id="mfa-password-reset-interval" class="setting-header"
                       aria-label="Allow Cigent endpoints to auto update">
                      <label class="setting-title">{{'2FA_PASSWORD_RESET_INTERVAL' | translate}}</label>
                      <label class="setting-description">{{'2FA_PASSWORD_RESET_INTERVAL_DESCRIPTION' | translate}}</label>
                  </div>
                  <div>
                        <app-numeric-input
                                id="mfa-password-reset-interval-input"
                                aria-labelledby="mfa-password-reset-interval"
                                [min]="1" [max]="12" step="1" [value]="mfaPwExpInterval"
                                [showProgressBar]="true"
                                labelPosition="left"
                                inputPosition="right"
                                [showMinMax]="true"
                                (valueChanged)="onMfaPassIntervalChanged($event)">
                        </app-numeric-input>
                </div>
              </div>
              <span *ngIf="showEnableLimitAuthTrys">
                  <h2>{{'ENDPOINT' | translate}}</h2>
                  <div class="setting-wrapper">
                      <div id="enable-max-pin-attempts" class="setting-header"
                           aria-label="Limit failed pin attempts">
                          <label class="setting-title">{{'LIMIT_AYTH_TRYS_TITLE' | translate}}</label>
                          <label class="setting-description">{{'LIMIT_AUTH_TRYS_DESC' | translate}}</label>
                      </div>
                      <div>
                          <mat-slide-toggle
                                  labelPosition="before"
                                  aria-labelledby="enable-max-pin-attempts"
                                  color="primary"
                                  id="enable-max-pin-toggle"
                                  [disableRipple]="true"
                                  (change)="onToggleSetting('enableLimitAuthTrys', $event.checked)"
                                  [checked]="enableLimitAuthTrys">
                              {{enableLimitAuthTrys ? ('ON' | translate) : ('OFF' | translate)}}
                          </mat-slide-toggle>
                      </div>
                  </div>
              </span>
          </mat-tab>

          <mat-tab label="{{'ORG_ORG' | translate}}">
              <form [formGroup]="orgFormGroup" (keydown.enter)="$event.preventDefault()" (keydown.shift.enter)="$event.preventDefault()">
                  <div class="setting-wrapper">
                          <div id="company-name-label" class="setting-header"
                               aria-label="Company Name">
                              <label class="setting-title">{{'ORG_NAME' | translate}}</label>
                              <label class="setting-description">{{'ORG_NAME_DESCR' | translate}}</label>
                          </div>
                          <div>
                            <mat-form-field class="settings-input" appearance="outline">
                                <input matInput class="settings-input" id="company-name" type="text" formControlName="orgName" (keydown)="onCompanyChange()"/>
                                <mat-error *ngIf="orgFormGroup.controls['orgName'].errors?.required">{{'COMPANY_NAME_REQ' | translate}}</mat-error>
                                <mat-error *ngIf="orgFormGroup.controls['orgName'].errors?.maxlength">{{'COMPANY_NAME_INVALID' | translate}}</mat-error>
                            </mat-form-field>
                          </div>
                  </div>
                  <div class="setting-wrapper">
                         <div id="contact-label" class="setting-header"
                               aria-label="Contact Name">
                              <label class="setting-title">{{'CONTACT_EMAIL' | translate}}</label>
                              <label class="setting-description">{{'CONTACT_EMAIL_DESCR' | translate}}</label>
                          </div>
                          <div>
                            <mat-form-field class="settings-input" appearance="outline">
                                <input matInput class="settings-input" id="contact" type="text" formControlName="contactEmail" (keydown)="onContactChange()"/>
                                <mat-error *ngIf="orgFormGroup.controls['contactEmail'].errors?.required">{{'EMAIL_REQ' | translate}}</mat-error>
                                <mat-error *ngIf="orgFormGroup.controls['contactEmail'].errors?.pattern">{{'APU_EMAIL_INVALID' | translate}}</mat-error>
                                <mat-error *ngIf="!orgFormGroup.controls['contactEmail'].errors?.pattern &&
                                                  orgFormGroup.controls['contactEmail'].errors?.maxlength">{{'APU_EMAIL_INVALID' | translate}}</mat-error>
                            </mat-form-field>
                          </div>
                  </div>
                  <div class="setting-wrapper">
                      <div id="require_two-factor" class="setting-header"
                           aria-label="Setting to make 2FA optional, required for admins/approvers, or required for all.">
                          <label class="setting-title">{{'2FA_REQUIRE_TITLE' | translate}}</label>
                          <label class="setting-description">{{'2FA_REQUIRE_DESCRIPTION' | translate}}</label>
                      </div>
                      <div>
                        <mat-radio-group formControlName="requireTwoFactor" (change)="onRequire2FAChanged()" class="settings-radio-group" aria-label="Select an option">
                          <mat-radio-button id="optional-for-all" class="settings-radio-button" [value]="required2FaType.Optional">{{'2FA_REQUIRE_OPTIONAL' | translate}}</mat-radio-button>
                          <mat-radio-button id="required-for-admins" class="settings-radio-button" [value]="required2FaType.AdminOrReseller">{{'2FA_REQUIRED_ADMINS_APPROVERS' | translate}}</mat-radio-button>
                          <mat-radio-button id="required-for-all" class="settings-radio-button" [value]="required2FaType.All">{{'2FA_REQUIRED_ALL' | translate}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                  </div>
                  <div class="setting-wrapper">
                      <div id="security-approval-method" class="setting-header"
                           aria-label="Choose the requirements for security approvals">
                          <label class="setting-title">{{'SECURITY_APPROVAL_METHOD' | translate}}</label>
                          <label class="setting-description">{{'SECURITY_APPROVAL_METHOD_DESCRIPTION' | translate}}</label>
                      </div>
                      <div *ngrxLet="restConfig$ as restConfig">
                        <mat-radio-group formControlName="securityApprovalMethod" (change)="onSecurityApprovalMethodChanged()" class="settings-radio-group" aria-label="Select an option">
                          <mat-radio-button id="sixty-percent-rule" class="settings-radio-button" [value]="securityApprovalMethodType.PERCENT_RULE">{{'PERCENT_RULE' | translate : {percent: restConfig?.security_request_min_percent} }}</mat-radio-button>
                          <mat-radio-button id="plus-one-rule" class="settings-radio-button" [value]="securityApprovalMethodType.PLUS_ONE_RULE">{{'PLUS_ONE_RULE' | translate}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                  </div>
                  <div class="setting-wrapper">
                      <div id="max-endpoint-inactivity-days" class="setting-header" style="flex-grow: 1;"
                           aria-label="Allow Cigent endpoints to auto update">
                          <label class="setting-title">{{'ENDPOINT_INACTIVITY_TITLE' | translate}}</label>
                          <label class="setting-description">{{'ENDPOINT_INACTIVITY_DESCRIPTION' | translate}}</label>
                      </div>
                      <mat-checkbox [checked]="useInactiveSystemDefault" name="makeDefault"
                                    (change)="onDefaultCheckChanged($event)" color="primary" data-lpignore="true">
                          <span class="make-default-label">{{'USE_SYSTEM_DEFAULT' | translate}}</span>
                      </mat-checkbox>
                      <div>
                        <app-numeric-input
                            id="max-endpoint-inactivity-days-input"
                            aria-labelledby="max-endpoint-inactivity-days"
                            [min]="endpointInactiveIntervalMin" [max]="endpointInactiveIntervalMax" step="1" [value]="endpointInactiveInterval"
                            [showProgressBar]="false"
                            labelPosition="right"
                            inputPosition="right"
                            label="days"
                            [showMinMax]="false"
                            [disabled]="useInactiveSystemDefault"
                            (valueChanged)="onInactiveIntervalChanged($event)">
                        </app-numeric-input>
                      </div>
                  </div>
                  <div class="setting-wrapper" *ngIf="showDeleteOrgButton">
                      <div id="delete-organization-request" class="setting-header"
                           aria-label="Request to delete this organization">
                          <label class="setting-title">Delete Organization Request</label>
                          <label class="setting-description">Send a request to delete this organization, its users, and data.</label>
                      </div>
                      <div>
                        <button mat-raised-button [disabled]="disableSubmit"
                                appThrottleClick throttleTime="5000" (throttleClick)="submitDeleteRequest()" color="warn">
                                {{'delete-data-request.submit-request' | translate}}
                        </button>
                      </div>
                  </div>
              </form>
          </mat-tab>

          <mat-tab label="Advanced" *ngIf="(showEnableSingleUserMode || allAdminSettingsViewable) && haveDDTier">
              <div *ngIf="showEnableSingleUserMode" class="setting-wrapper">
                  <div id="single-user-mode-header" class="setting-header"
                       aria-label="Enable single user mode">
                      <label class="setting-title">{{'SINGLE_USER_MODE_TITLE' | translate}}</label>
                      <label class="setting-description">{{'SINGLE_USER_MODE_DESC' | translate}}</label>
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="single-user-mode-toggle"
                          color="primary"
                          id="single-user-mode-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableSingleUserMode', $event.checked)"
                          [checked]="enableSingleUserMode">
                          {{enableSingleUserMode ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
              </div>
              <div *ngIf="this.allAdminSettingsViewable" class="setting-wrapper" matRipple
                 [matRippleTrigger]="hiddenTigger">
                  <div id="enable-ssd-pwd-backup" class="setting-header"
                       aria-label="Enable collection of Secure Drive password backup files">
                      <label class="setting-title">{{'admin.settings.enable_ssd_pwd_backup' | translate}}</label>
                      <label class="setting-description">{{'admin.settings.enable_ssd_pwd_backup_descr' | translate}}</label>
                  </div>
                  <div>
                      <mat-slide-toggle
                          labelPosition="before"
                          aria-labelledby="ssd-pwd-backup-toggle"
                          color="primary"
                          id="ssd-pwd-backup-toggle"
                          [disableRipple]="true"
                          (change)="onToggleSetting('enableSsdPwdBackup', $event.checked)"
                          [checked]="enableSsdPwdBackup">
                          {{enableSsdPwdBackup ? ('ON' | translate) : ('OFF' | translate)}}
                      </mat-slide-toggle>
                  </div>
              </div>
              <span #hiddenTigger></span>
          </mat-tab>

        </mat-tab-group>
    </div>
	<ng-template #noAdminSettings>
		<div *ngIf="settingsDataLoaded" class="no-admin-settings">
			{{fNone}}
		</div>
	</ng-template>


</div>
